import { createTheme } from '@mui/material/styles';
import blue from '@mui/material/colors/blue';
import grey from '@mui/material/colors/grey';

export default createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'IRANYekan, sans-serif'
  },
  palette: {
    primary: {
      main: blue['700']
    },
    secondary: {
      main: blue['100']
    },
    dark: {
      main: grey[300],
      light: '#eff1f7'
    },
    background: {
      main: grey[50],
      light: '#ffffff'
    }
  }
});
